import { ArrowRight, ArrowUpRight } from "lucide-react";
import { CAPABILITIES } from "../../data/content";

export const Capabilities = () => (
  <section id="capabilities" className="bg-[#0A0A0A] px-6 lg:px-12 py-24 lg:py-32" data-testid="capabilities-section">
    <div className="flex items-end justify-between mb-14">
      <p className="font-mono text-xs tracking-[0.35em] text-white/50 flex items-center gap-4">
        OUR CAPABILITIES <span className="inline-block w-16 h-px bg-white/20" />
      </p>
      <span className="hidden md:inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] text-white/40">
        VIEW ALL CAPABILITIES <ArrowRight className="w-3.5 h-3.5" />
      </span>
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 border border-white/10">
      {CAPABILITIES.map((c) => (
        <article
          key={c.n}
          data-testid={`capability-card-${c.n}`}
          className="group border-white/10 max-sm:border-b sm:max-lg:odd:border-r sm:max-lg:[&:nth-child(n+3)]:border-t lg:not-first:border-l"
        >
          <div className="relative overflow-hidden aspect-[4/3]">
            <img
              src={c.img}
              alt={c.title}
              loading="lazy"
              className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700"
            />
            <span className="absolute top-4 left-4 font-mono text-[10px] tracking-[0.25em] text-white/80 bg-black/50 px-2 py-1">
              {c.n}
            </span>
          </div>
          <div className="p-6 lg:p-8">
            <h3 className="font-display text-2xl text-white">{c.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60">{c.desc}</p>
            <ArrowUpRight className="mt-6 w-4 h-4 text-white/40 group-hover:text-white transition-colors duration-300" />
          </div>
        </article>
      ))}
    </div>
  </section>
);
